.container {
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: black;
  color: white;
}
